if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

            if (!this.productElement) return;

            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient') {
                this.modalContent.classList.add(classApplied);
              }
            });

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            this.setupMPMVariantImage(opener);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');

            const spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

            setupMPMVariantImage(opener) {
        const modalContent = this.modalContent;
        if (!modalContent || !opener) return;

        const rawProductUrl = opener.getAttribute('data-product-url');
        if (!rawProductUrl) return;

        const productPath = rawProductUrl.split('?')[0].replace(/\/$/, '');
        const productJsonUrl = `${productPath}.js`;

        if (modalContent.querySelector('.mpm-quickadd-variant-media')) return;

        const mediaBox = document.createElement('div');
        mediaBox.className = 'mpm-quickadd-variant-media';

        const image = document.createElement('img');
        image.className = 'mpm-quickadd-variant-image';
        image.alt = '';

        mediaBox.appendChild(image);

        const productWrapper = modalContent.querySelector('.product');
        if (productWrapper) {
          productWrapper.insertBefore(mediaBox, productWrapper.firstChild);
        } else {
          modalContent.prepend(mediaBox);
        }

        fetch(productJsonUrl)
          .then((response) => response.json())
          .then((productData) => {
            function getSelectedOptions() {
              const selectElements = modalContent.querySelectorAll('variant-selects select, variant-radios select');

              if (selectElements.length) {
                return Array.from(selectElements).map((select) => select.value);
              }

              const fieldsets = Array.from(
                new Set(
                  Array.from(
                    modalContent.querySelectorAll('variant-selects fieldset, variant-radios fieldset, .product-form__input')
                  )
                )
              );

              const selectedOptions = [];

              fieldsets.forEach((fieldset) => {
                const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
                if (checkedInput) selectedOptions.push(checkedInput.value);
              });

              return selectedOptions;
            }

            function getSelectedVariant() {
              const hiddenVariantInput = modalContent.querySelector(
                'input.product-variant-id[name="id"], form[action*="/cart/add"] input[name="id"]'
              );

              if (hiddenVariantInput && hiddenVariantInput.value) {
                const variantById = productData.variants.find((variant) => {
                  return String(variant.id) === String(hiddenVariantInput.value);
                });

                if (variantById) return variantById;
              }

              const selectedOptions = getSelectedOptions();

              if (selectedOptions.length) {
                const variantByOptions = productData.variants.find((variant) => {
                  return variant.options.every((option, index) => option === selectedOptions[index]);
                });

                if (variantByOptions) return variantByOptions;
              }

              return productData.variants[0];
            }

            function updateVariantImage() {
              const selectedVariant = getSelectedVariant();

              const imageSrc =
                selectedVariant &&
                selectedVariant.featured_image &&
                selectedVariant.featured_image.src
                  ? selectedVariant.featured_image.src
                  : productData.featured_image || productData.images[0];

              if (!imageSrc) {
                mediaBox.style.display = 'none';
                return;
              }

              mediaBox.style.display = '';
              image.src = imageSrc;
              image.alt = selectedVariant ? selectedVariant.title : productData.title;
            }

            updateVariantImage();

            modalContent.addEventListener('change', () => {
              setTimeout(updateVariantImage, 120);
            });

            modalContent.addEventListener('click', (event) => {
              if (event.target.closest('label, input, select')) {
                setTimeout(updateVariantImage, 180);
              }
            });
          })
          .catch(() => {
            mediaBox.style.display = 'none';
          });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        const mediaImageSizes = '220px';

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}